import React, { useState, useEffect } from "react";
import Header from "../../Core/Header";
import axios from "axios";
import { toast } from "react-toastify";
import {
  categoryAssign,
  EmployeeCategory,
  employeeRoleApi,
  employeeRoleAssign,
  get_EmployeeRole,
} from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Section } from "../../Core/Section";

const EmployeeAssign = () => {
  const location = useLocation();
  const [EmployeeType, setEmployeeType] = useState("");
  const [EmployeeselectId, setEmployeeselectId] = useState("");
  const [formData, setFormData] = useState({});
  const [EmployeeAssign, setEmployeeAssign] = useState([]);
  const [employeeAssignList, setEmployeeAssignList] = useState([]);
  const [cartUpdated, setEmployeeAssignUpdated] = useState(false);
  const { EmployeeSelectId } = location.state || {};
    const token = useSelector((state) => state.user.token);
    console.log("token : ", token);

  console.log("EmployeeSelectId : ", EmployeeSelectId);
  useEffect(() => {
    if (EmployeeSelectId) {
      setEmployeeselectId(EmployeeSelectId);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const submissionData = {
      employeeRoleId: EmployeeType,
      employeeId: EmployeeSelectId,
    };

    try {
      const response = await employeeRoleAssign(submissionData,token);
      console.log("Response for assign:", response);

      if (response.status === 201) {
        console.log("Success");
        toast.success("Employee assigned successfully");
        setEmployeeType("");
      } else {
        console.log("Error:", response.message);
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const fetchEmployeeRole = async () => {
      try {
        const response = await get_EmployeeRole(token);
        console.log("EmployeeAssign list:", response.data);
        setEmployeeAssignList(response.data);
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

    fetchEmployeeRole();
  }, []);

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">EmployeeAssigns</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    EmployeeAssigns
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Student-add">
                <div className="row clearfix">
                  <div className="col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Basic Information</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <form className="card-body" onSubmit={handleSubmit}>
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Select Employee Type{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-9">
                            <select
                              className="form-control"
                              value={EmployeeType}
                              onChange={(e) => {
                                setEmployeeType(e.target.value);
                              }}
                              required
                            >
                              <option value="">Select Employee Category</option>
                              {employeeAssignList.map((employee) => (
                                <option key={employee.id} value={employee.id}>
                                  {employee.id===1?"Senior Marketing Executive":employee.id===2?"Junior Marketing Executive":
                                  employee.id===8?"Regional Manger":  employee.employeeRoleName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {/* Submit Button */}
                        <div className="col-sm-12">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={!EmployeeType}
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default EmployeeAssign;
